import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FILE_UPLOAD_SERVICE } from '../components/drag-and-drop-upload/service/file-upload.service.provider';
import { IFileUploadService, UploadProgress } from '../components/drag-and-drop-upload/service/file-upload.service.interface';
import { DocumentApiService } from '../api/document-api.service';

@Injectable({
  providedIn: 'root',
})
export class ObjectStorageService {
  constructor(
    @Inject(FILE_UPLOAD_SERVICE) private readonly uploadAdapter: IFileUploadService,
    private readonly documentApi: DocumentApiService,
  ) {}

  // Delegates to the HTTP/in-memory adapter selected by environment config -
  // this is not a second upload path, just the single call-in point for it.
  upload(file: File): Observable<UploadProgress> {
    return this.uploadAdapter.upload(file);
  }

  resolveDownload(ref: string): Observable<string> {
    return this.documentApi
      .getDownloadUrl(this.parseKey(ref))
      .pipe(map(({ downloadUrl }) => downloadUrl));
  }

  openDownload(ref: string): void {
    this.resolveDownload(ref).subscribe((downloadUrl) => {
      window.open(downloadUrl, '_blank');
    });
  }

  private parseKey(ref: string): string {
    if (ref.startsWith('s3')) {
      return ref.substring(ref.indexOf('/', 5) + 1);
    }
    const safeUrl = ref.replace(/#/g, '%23');
    const url = new URL(safeUrl);
    return decodeURIComponent(url.pathname.substring(1));
  }
}
